import * as Yup from "yup";

export const customAddressValidation = Yup.object().shape({
  pinFl: Yup.string()
    .required("validations_pinfl")
    .length(14, "validations_pinfl_must_contain_numbers_length"),
  cardId: Yup.string()
    .required("validations_card_id")
    .length(9, "validations_id_passport_must_contain_9_characters"),
  addressLabel: Yup.string().required("validations_address_label"),
  streetName: Yup.string().required("validations_street_name"),
  lastName: Yup.string()
    .matches(/^[\u0400-\u04FF]+$/, "validations_only_cyrillic_letters")
    .required("validations_last_name"),
  firstName: Yup.string()
    .matches(/^[\u0400-\u04FF]+$/, "validations_only_cyrillic_letters")
    .required("validations_first_name"),
  regionId: Yup.object()
    .shape({
      id: Yup.number().required("validations_region_address"),
      mainText: Yup.string(),
    })
    .required(),
  cityId: Yup.object()
    .shape({
      id: Yup.number().required("validations_city"),
      mainText: Yup.string(),
    })
    .required(),
  dateOfBirth: Yup.string().required("validations_date_of_birth"),
  phone: Yup.string().required("validations_phone"),
});

export const customAddressValidationUk = Yup.object().shape({
  addressLabel: Yup.string().required("validations_address_label"),
  streetName: Yup.string().required("validations_street_name"),
  lastName: Yup.string()
    .matches(/^[\u0400-\u04FF'\-]+$/, "validations_only_cyrillic_letters")
    .required("validations_last_name"),
  firstName: Yup.string()
    .matches(/^[\u0400-\u04FF'\-]+$/, "validations_only_cyrillic_letters")
    .required("validations_first_name"),
  regionId: Yup.object()
    .shape({
      id: Yup.number().required("validations_region_address"),
      mainText: Yup.string(),
    })
    .required(),
  cityId: Yup.object()
    .shape({
      id: Yup.number().required("validations_city"),
      mainText: Yup.string(),
    })
    .required(),
  houseNumber: Yup.string().required("validations_house_number"),
  apartmentNumber: Yup.string(),
  middleName: Yup.string()
    .matches(/^[\u0400-\u04FF'\-]+$/, "validations_only_cyrillic_letters")
    .required("validations_middle_name"),
});

// @ts-ignore
export const deliveryAddressValidationUz: Yup.ObjectSchema<TDeliveryAddressFormUz> =
  Yup.object().shape({
    addressLabel: Yup.string()
      .max(25, "validations_address_label_length")
      .required("validations_address_label"),
    streetName: Yup.string().required("validations_street_name"),
    lastName: Yup.string()
      .matches(/^[\u0400-\u04FF]+$/, "validations_only_cyrillic_letters")
      .required("validations_last_name"),
    firstName: Yup.string()
      .matches(/^[\u0400-\u04FF]+$/, "validations_only_cyrillic_letters")
      .required("validations_first_name"),
    phone: Yup.string().required("validations_phone"),
    regionId: Yup.object()
      .shape({
        id: Yup.number().required("validations_region_address"),
        mainText: Yup.string(),
      })
      .required("validations_region_address"),
    cityId: Yup.object()
      .shape({
        id: Yup.number().required("validations_city"),
        mainText: Yup.string(),
      })
      .required("validations_city"),
    nationalDeliveryPayTypeId: Yup.object()
      .shape({
        id: Yup.number().required("validations_payment_method"),
        mainText: Yup.string(),
      })
      .required("validations_payment_method"),
    nationalDeliveryCostTypeId: Yup.object()
      .shape({
        id: Yup.number().required("validations_the_value_of_parcel"),
        mainText: Yup.string(),
      })
      .required("validations_the_value_of_parcel"),
  });

// @ts-ignore
export const deliveryAddressValidationGe: Yup.ObjectSchema<TDeliveryAddressFormGe> =
  Yup.object().shape({
    addressLabel: Yup.string()
      .max(25, "validations_address_label_length")
      .required("validations_address_label"),
    streetName: Yup.string().required("validations_street_name"),
    firstName: Yup.string()
      .matches(/^[ა-ჰa-zA-Z\s]+$/, "validations_first_name_georgian_or_latin")
      .required("validations_first_name"),
    lastName: Yup.string()
      .matches(/^[ა-ჰa-zA-Z\s]+$/, "validations_last_name_georgian_or_latin")
      .required("validations_last_name"),
    phone: Yup.string().required("validations_phone"),
    cityId: Yup.object()
      .shape({
        id: Yup.number().required("validations_city"),
        mainText: Yup.string(),
      })
      .required("validations_city"),
    // nationalDeliveryPayTypeId: Yup.object()
    //   .shape({
    //     id: Yup.number().required("validations_payment_method"),
    //     mainText: Yup.string(),
    //   })
    //   .required("validations_payment_method"),
  });

// @ts-ignore
export const deliveryAddressValidationUa: Yup.ObjectSchema<TDeliveryAddressFormUa> =
  Yup.object().shape({
    addressLabel: Yup.string()
      .max(25, "validations_address_label_length")
      .required("validations_address_label"),
    streetName: Yup.string().when("typeDeliveryId", {
      is: 2,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema
          .matches(
            /^[\u0400-\u04FF0-9.\/ \-'`]+$/,
            "validations_only_cyrillic_street_name"
          )
          .required("validations_street_name"),
    }),
    lastName: Yup.string()
      .matches(/^[\u0400-\u04FF'\-]+$/, "validations_only_cyrillic_letters")
      .required("validations_last_name"),
    firstName: Yup.string()
      .matches(/^[\u0400-\u04FF'\-]+$/, "validations_only_cyrillic_letters")
      .required("validations_first_name"),
    middleName: Yup.string()
      .matches(/^[\u0400-\u04FF'\-]+$/, "validations_only_cyrillic_letters")
      .required("validations_middle_name"),
    phone: Yup.string()
      .required("validations_phone")
      .test(
        "phone-length",
        "validations_phone_must_be_9_digits",
        function (value) {
          if (value.startsWith("+998")) {
            const phoneDigits = value.replace(/^\+998/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+995")) {
            const phoneDigits = value.replace(/^\+995/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+380")) {
            const phoneDigits = value.replace(/^\+380/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+1")) {
            return true;
          }
          return false;
        },
      ),
    regionId: Yup.object()
      .shape({
        id: Yup.number().required("validations_region_address"),
        mainText: Yup.string(),
      })
      .required("validations_region_address"),
    cityId: Yup.object()
      .shape({
        id: Yup.number().required("validations_city"),
        mainText: Yup.string(),
      })
      .required("validations_city"),
    nationalDeliveryPayTypeId: Yup.object()
      .shape({
        id: Yup.number().required("validations_payment_method"),
        mainText: Yup.string(),
      })
      .required("validations_payment_method"),
    nationalDeliveryCostTypeId: Yup.object()
      .shape({
        id: Yup.number().required("validations_the_value_of_parcel"),
        mainText: Yup.string(),
      })
      .required("validations_the_value_of_parcel"),
    typeDeliveryId: Yup.number().required("validations_delivery_type"),
  });
